document.addEventListener('turbo:load', (): void => {
  const addAnotherRaceItem = (i: number): void => {
    const container = document.getElementById(`attribute_${i}_options`)
    if (container) {
      container.insertAdjacentHTML('beforeend', `
        <input type="text" name="race_item[attribute_${i}_options][]" aria-label="Attribute ${i} option" class="form-control w-full mb-2">
      `)
      container.querySelector<HTMLInputElement>('input:last-of-type')?.focus()
    }
  }

  document.getElementById('race_item_add_option_1')?.addEventListener('click', () => addAnotherRaceItem(1))
  document.getElementById('race_item_add_option_2')?.addEventListener('click', () => addAnotherRaceItem(2))
})
